import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Typography, Checkbox, Button, Card, Spin} from 'antd'
import {FilePdfOutlined} from '@ant-design/icons'
import {observer} from 'mobx-react'
import {Modal} from '@/components'
import {ReviewAndSignModalProps} from './props'
import styles from './ReviewAndSignModal.scss'

const {Text} = Typography

export const ReviewAndSignModal: React.FC<ReviewAndSignModalProps> = observer(
    ({open, onCancel, onDownload, onSign, isPreviewLoading, isPreviewReady, isSigningContract}) => {
        const {t} = useTranslation()
        const [agreed, setAgreed] = useState(false)

        const handleClose = () => {
            setAgreed(false)
            onCancel()
        }

        return (
            <Modal
                title={t('ReviewAndSignModal.title')}
                open={open}
                onCancel={handleClose}
                footer={
                    <div className={styles.footer}>
                        <Button
                            type='primary'
                            onClick={onSign}
                            disabled={!agreed}
                            loading={isSigningContract}
                            aria-busy={isSigningContract}
                        >
                            {t('ReviewAndSignModal.buttons.sign')}
                        </Button>
                    </div>
                }
                width={600}
            >
                <div className={styles.content}>
                    <Text type='secondary'>
                        {t('ReviewAndSignModal.disclaimer')}
                    </Text>
                    <Text type='secondary'>
                        {t('ReviewAndSignModal.description')}
                    </Text>

                    <Card
                        className={styles.previewCard}
                        hoverable={isPreviewReady}
                        onClick={isPreviewReady ? onDownload : undefined}
                    >
                        <FilePdfOutlined className={styles.previewIcon} />
                        <span>{t('ReviewAndSignModal.buttons.previewContract')}</span>
                        {isPreviewLoading && <Spin size='small' className={styles.previewSpin} />}
                    </Card>

                    <Checkbox
                        checked={agreed}
                        onChange={(e) => setAgreed(e.target.checked)}
                    >
                        {t('ReviewAndSignModal.agreeTerms')}
                    </Checkbox>
                </div>
            </Modal>
        )
    }
)
